import { Row, Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'
import React from 'react'

const marginOverrideCss = css`
  & button,
  a {
    margin: 0;
  }
`

type Props = {
  hideText?: boolean
}

export default function BannerActionsSkeleton({ hideText }: Props): JSX.Element {
  return (
    <div css={marginOverrideCss}>
      {hideText ? (
        <Row wrap alignY="middle" guttersY="nano" guttersX="xxs">
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <Skeleton.IconButton />
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <Skeleton.IconButton />
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <Skeleton.IconButton />
        </Row>
      ) : (
        <Row wrap alignY="middle" guttersY="nano" guttersX="xxs">
          <Skeleton.Button data-testid="banner-actions-skeleton-button-1" minWidth={120} />
          <Skeleton.Button data-testid="banner-actions-skeleton-button-2" minWidth={190} />
          <Skeleton.Button data-testid="banner-actions-skeleton-button-3" minWidth={130} />
        </Row>
      )}
    </div>
  )
}
